exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/*!\n * Font Awesome Pro 6.0.0-alpha2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license (Commercial License)\n */@font-face{font-family:Font Awesome\\ 6 Pro;font-style:normal;font-weight:900;font-display:block;src:url(" + require("../webfonts/fa-solid-900.woff2") + ") format(\"woff2\"),url(" + require("../webfonts/fa-solid-900.woff") + ") format(\"woff\"),url(" + require("../webfonts/fa-solid-900.ttf") + ") format(\"truetype\")}.fa-solid,.fas{font-family:Font Awesome\\ 6 Pro;font-weight:900}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./libs/font-awesome/scss/solid.scss
// module id = 353
// module chunks = 0